module.exports = __webpack_public_path__ + "static/media/notifications-unread.4944831b.svg";